// Shared status → badge lookup for every "project card" style grid/slider
// (GalerieProjectsSlider, PortfolioGrid). Edit here to change a badge's
// label or color everywhere it's used.
export const STATUS_META = {
  "in-development": { label: "In Development", className: "in-dev" },
  "expansion-underway": {
    label: "Expansion Underway",
    className: "expansion",
  },
  "under-construction": {
    label: "Under Construction",
    className: "in-dev",
  },
  "galerie-built": { label: "Galerie-Built", className: "in-dev" },
  managed: { label: "Managed", className: "open" },
};
export const OPEN_STATUS_META = { label: "Stabilized", className: "open" };
